import { PROD } from '../../../config/stage'
import apiBaseUrl from '../baseUrl'

const stagePrefix = import.meta.env.VITE_STAGE === PROD ? '' : 'test-'
const insightsBaseUrl = `${apiBaseUrl}${stagePrefix}insights`

export default insightsBaseUrl
